import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
import dayjs from "dayjs";
import { useState } from "react";
import { InvoiceStatus, InvoiceStatusProps } from "../Billing/InvoiceStatus";

export type InvoiceStatusChipProps = InvoiceStatusProps;
export const InvoiceStatusChip: React.FC<InvoiceStatusChipProps> = ({
  invoice,
  className,
}) => {
  // We do not want this "now" to change over the life of this component.
  const [now] = useState(() => dayjs());
  const paymentDays = dayjs(invoice.payment_due_date).diff(now, "days");
  const scaffold = useScaffold();
  const commonClassName = "rounded-sm px-1 py-0.5 pt-1 border";
  if (invoice.paid_at) {
    return (
      <InvoiceStatus
        invoice={invoice}
        className={clsx(
          commonClassName,
          "bg-green-100 border-green-200",
          className,
        )}
      />
    );
  }
  if (invoice.is_deferred || invoice.rebill_invoice) {
    return (
      <InvoiceStatus
        invoice={invoice}
        className={clsx(
          commonClassName,
          "border-gray-200 bg-gray-50",
          className,
        )}
      />
    );
  }
  if (paymentDays < 0) {
    return (
      <InvoiceStatus
        invoice={invoice}
        className={clsx(
          commonClassName,
          "border-red-200",
          scaffold.page.colors.background.error,
          className,
        )}
      />
    );
  }
  return (
    <InvoiceStatus
      invoice={invoice}
      className={clsx(
        commonClassName,
        "bg-orange-100 border-orange-200",
        className,
      )}
    />
  );
};
